<template>
    <div class="h-100">
        <b-container fluid class="p-0">
            <b-row align-h="center">
                <b-col md="10">
                    <h1 class="mb-2">{{ $t("exports.title") }}</h1>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-card :img-src="conversationExportsImage" class="mr-5" style="max-width: 25rem">
                    <template #header>
                        <h4>{{ $t("exports.conversations.title") }}</h4>
                    </template>
                    <b-card-text class="text-secondary">{{ $t("exports.conversations.description") }}</b-card-text>
                    <template #footer>
                        <b-button
                            :to="{ name: 'secure-exports-conversations' }"
                            variant="primary"
                            class="mb-50 font-small-3"
                        >
                            {{ $t("exports.export") }}
                        </b-button>
                    </template>
                </b-card>
                <b-card :img-src="contactExportsImage" class="ml-5" style="max-width: 25rem">
                    <template #header>
                        <h4>{{ $t("exports.contacts.title") }}</h4>
                    </template>
                    <b-card-text class="text-secondary">{{ $t("exports.contacts.description") }}</b-card-text>
                    <template #footer>
                        <b-button
                            :to="{ name: 'secure-exports-contacts' }"
                            variant="primary"
                            class="mb-50 font-small-3"
                        >
                            {{ $t("exports.export") }}</b-button
                        >
                    </template>
                </b-card>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import { BAlert, BButton, BCalendar, BCol, BContainer, BRow, BSpinner, BCard, BCardText } from "bootstrap-vue";

export default {
    components: {
        BContainer,
        BCalendar,
        BButton,
        BSpinner,
        BRow,
        BCol,
        BAlert,
        BCard,
        BCardText,
    },
    setup() {
        const contactExportsImage = require("@/assets/images/exportContacts.svg");
        const conversationExportsImage = require("@/assets/images/secureExportImage.svg");

        return {
            contactExportsImage,
            conversationExportsImage,
        };
    },
};
</script>
